import React, { useState} from "react";
import { useNavigate } from "react-router-dom";
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";
import normatecaStore from "../../../stores/normatecaStore";

export default function MenuLat(){
    const navigate= useNavigate();
    const [visMenuP,setVisMenuP]=useState(true);
    // store - zuntand
    const {menuLat,setOpenCloseMenu} =
    normatecaStore((state) =>( { 
        menuLat: state.menuLat,
        setOpenCloseMenu: state.setOpenCloseMenu,
    })); 

    const visualizaMenu=()=>{
        setVisMenuP(!visMenuP);
    }
    const openCloseMenu=(indices)=>{
        setOpenCloseMenu(indices,menuLat);
    }
    const cambiaContenido =(opcVis, indices)=>{
        setVisMenuP(false);  
        navigate("/app/normateca/menu=" + opcVis + "_" + indices);
     }

    return(
             /* menu */
            <div className={visMenuP? "divMenuLat" : "divMenuLatClose"}>
                <Accordion className="divAcoordion">
                    <AccordionItem key={0} >
                        <AccordionHeader className="menuLat" onClick={visualizaMenu}>
                            <span className="inegi-menudesplegable imgMenuLat"></span>
                            {/* <AiOutlineLeft className="imgMenuLat"/><FiMenu className="imgMenuLat"/> */}
                        </AccordionHeader>
                        <AccordionBody className={visMenuP? 'display-contents' : 'display-none'}>
                            <div className="accordion-body" key={"div1"} >
                                
                                {menuLat.nivel2?.map((m,index)=>(
                                    <AccordionItem key={"aci" + index.toString()}>
                                    {m.nivel3?.length=== 0 ?
                                        <div className="display-flex" key={"divDF1" + index.toString()}>
                                            <div className={m.seleccionado? 'divOpcSel backColor-blue3' : 'divOpcSel'}></div>
                                            <div className={m.seleccionado? 'accordion-body linkMenuLat1 color-blue2 backColor-blue1' : 'accordion-body linkMenuLat1 color-gray'} key={"mi" + index.toString()} onClick={()=>cambiaContenido(m.id, index)}>
                                                {m.nombre}
                                            </div>
                                        </div>
                                    :
                                        <div key={"mh" + index.toString()} >
                                            <AccordionHeader key={"mah" + index.toString()} className={m.seleccionado? 'btnMenuLat1 color-blue2 backColor-blue1' : 'btnMenuLat1 color-gray'} onClick={()=> openCloseMenu(index)}>
                                                <div className="display-flex" key={"divDF2" + index.toString()}>
                                                    <div className={m.seleccionado? 'divOpcSel backColor-blue1': 'divOpcSel'}></div>
                                                    <div className="width-95">{m.nombre}</div>
                                                    {m.visualiza?<div className="inegi-nav-despa alignSelf-center lineH-n"></div>:<div className="inegi-nav-desp alignSelf-center lineH-n"></div>}
                                                </div>
                                            </AccordionHeader>
                                            <AccordionBody key={"ab1" + index.toString()} className={m.visualiza? 'display-contents':'display-none'} >
                                            {m.nivel3?.map((m1,indexm1)=>(
                                                <AccordionItem key={"ai1" + indexm1.toString()}>
                                                    {m1['nivel4'] === undefined || m1.nivel4?.length === 0?
                                                        /* <AccordionItem key={"m1i" + indexm1.toString()}> */
                                                        <div className="display-flex" key={"divDF3" + indexm1.toString()}>
                                                            <div className={m1.seleccionado? 'divOpcSel backColor-blue3' : m.seleccionado? 'divOpcSel backColor-blue1' : 'divOpcSel'}></div>
                                                            <div className={m1.seleccionado? 'accordion-body linkMenuLat1 color-blue2 backColor-blue2' : m.seleccionado? 'accordion-body linkMenuLat1 backColor-blue1' : 'accordion-body linkMenuLat1'} key={"divm1" + indexm1.toString()} onClick={()=>cambiaContenido(m1.id, index + "-" + indexm1)}>
                                                                {m1.nombre}
                                                            </div>
                                                        </div>
                                                        /* </AccordionItem> */
                                                    :
                                                        <div key={"m1" + indexm1.toString()}>
                                                            <AccordionHeader key={"ac" + indexm1.toString()} className={m1.seleccionado? 'linkMenuLat1 color-blue2 backColor-blue1' : m.seleccionado? 'linkMenuLat1 backColor-blue1' : 'linkMenuLat1'} onClick={()=> openCloseMenu(index + "-" + indexm1)}>
                                                            <div className="display-flex" key={"divDF4" + indexm1.toString()}>
                                                                <div className={m1.seleccionado? 'divOpcSel backColor-blue1' : m.seleccionado? 'divOpcSel backColor-blue1': 'divOpcSel'}></div>
                                                                <div className="width-87">{m1.nombre}</div>
                                                                {m1.visualiza?<div className="inegi-nav-despa alignSelf-center lineH-n"></div>:<div className="inegi-nav-desp alignSelf-center lineH-n"></div>}
                                                            </div>
                                                            </AccordionHeader>
                                                            <AccordionBody key={"ab" + indexm1.toString()} className={m1.visualiza? 'display-contents' : 'display-none'}>
                                                            {m1.nivel4?.map((m2,indexm2)=>(
                                                                <div className="display-flex" key={"divDF5" + indexm2.toString()}>
                                                                    <div className={m2.seleccionado? 'divOpcSel backColor-blue3' : m.seleccionado? 'divOpcSel backColor-blue1': 'divOpcSel'}></div>
                                                                    <div className={m2.seleccionado? 'accordion-body linkMenuLat2 color-blue2 backColor-blue2' : m.seleccionado? 'accordion-body linkMenuLat2 backColor-blue1': 'accordion-body linkMenuLat2'} key={"m2" + indexm2.toString()} onClick={()=>cambiaContenido(m2.id, index + "-" + indexm1 + "-" + indexm2)}>
                                                                        {m2.nombre}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            </AccordionBody>
                                                        </div>
                                                    }
                                                </AccordionItem>
                                            ))}
                                            </AccordionBody>
                                        </div>
                                    }
                                    </AccordionItem>
                                ))}
                                
                            </div>
                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
            </div>
             
    ) 
}




